module.exports = __webpack_public_path__ + "static/media/silent-disco-2.a5a47137.jpeg";